import React, { Component } from 'react';
import { Field, reduxForm, FormSection } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui';
import validate from './validate';

class Amenities extends Component {
  render() {
    const { handleSubmit } = this.props;

    const styles = {
      checkbox: {
        marginBottom: '14px',
      },
    };

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <FormSection name="amenities">
            <div className="row" style={{ marginBottom: '70px' }}>
              <h3 style={{ textAlign: 'center', margin: '25px 0px 25px 0px' }}>
                Building Amenities
              </h3>
              <div className="row">
                <div className="col-sm-6" style={{ textAlign: 'center' }}>
                  <Field
                    name="kitchen"
                    label="Kitchen"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="concierge"
                    label="Concierge"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="mediaRoom"
                    label="Media Room"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="smoking"
                    label="Smoking"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="intercom"
                    label="Intercom"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field name="pool" label="Pool" component={Checkbox} style={styles.checkbox} />
                  <Field
                    name="family_kid_friendly"
                    label="Family Friendly"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="roof_top_deck"
                    label="Roof Top Deck"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="elevator_access"
                    label="Elevator Access"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="hot_tub_or_sauna"
                    label="Hot Tub/Sauna"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                </div>

                <div className="col-sm-6" style={{ textAlign: 'center' }}>
                  <Field
                    name="bbq_allowed"
                    label="BBQ Allowed"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="washer_dryer"
                    label="Washer/Dryer"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="cable_tv"
                    label="Cable TV"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="party_room"
                    label="Party Room"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field name="gym" label="Gym" component={Checkbox} style={styles.checkbox} />
                  <Field
                    name="pet_friendly"
                    label="Pet Friendly"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="guest_suites"
                    label="Guest Suites"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="visitor_parking"
                    label="Visitor Parking"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="indoor_fireplace"
                    label="Indoor Fireplace"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="wheelchair_access"
                    label="Wheelchair Access"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                </div>
              </div>

              <h3 style={{ textAlign: 'center', margin: '25px 0px 25px 0px' }}>Local Community</h3>
              <div className="row">
                <div className="col-sm-6" style={{ textAlign: 'center' }}>
                  <Field
                    name="bike_paths"
                    label="Bike Paths"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field name="bus" label="Bus" component={Checkbox} style={styles.checkbox} />
                  <Field
                    name="hospital"
                    label="Hospital"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="school"
                    label="School"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="shopping_center"
                    label="Shopping Center"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                </div>

                <div className="col-sm-6" style={{ textAlign: 'center' }}>
                  <Field name="park" label="Park" component={Checkbox} style={styles.checkbox} />
                  <Field
                    name="subway"
                    label="Subway"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="library"
                    label="Library"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="community_center"
                    label="Community Center"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                  <Field
                    name="sports_complex"
                    label="Sports Complex"
                    component={Checkbox}
                    style={styles.checkbox}
                  />
                </div>
              </div>
            </div>
          </FormSection>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(Amenities);
